import { c as _c } from "react/compiler-runtime";
import { Command } from 'cmdk';
import type React from 'react';
type ComboGroupProps = {
  children: React.ReactNode;
};
const ComboGroup: React.FC<ComboGroupProps> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Command.Group className="p-1">{children}</Command.Group>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default ComboGroup;